import React, { useEffect } from "react";

export function Home() {
  const iframeOrigin = "https://copilotstudio.microsoft.com"; // Update with your chatbot iframe's origin
  const iframeSrc =
    "https://copilotstudio.microsoft.com/environments/Default-ea4e030f-7c6e-43fc-83c8-b5af5b00dbbe/bots/crcae_loanRecommendation/webchat?__version__=2";

  useEffect(() => {
    // Listen for messages from the iframe
    const handleMessage = (event: MessageEvent) => {
      if (event.origin === iframeOrigin) {
        console.log("Received message from chatbot:", event.data);
        // Handle the chatbot's response here if needed
      } else {
        console.warn("Message received from unknown origin:", event.origin);
      }
    };

    // Add event listener for iframe communication
    window.addEventListener("message", handleMessage);

    // Cleanup listener on component unmount
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 flex flex-col">
      {/* Chatbot Iframe Section */}
      <div className="flex-1 overflow-y-auto p-4">
        <div className="iframe-container">
          <iframe
            src={iframeSrc}
            frameBorder="0"
            className="chatbot-iframe w-full h-96 rounded-md shadow-lg"
            title="Chatbot"
          ></iframe>
        </div>
      </div>

      {/* Footer Section */}
      <footer className="bg-gray-800 text-gray-300 py-4 text-center">
        <p className="text-sm">
          &copy; {new Date().getFullYear()} Duit Digital. All rights reserved.
        </p>
      </footer>
    </div>
  );
}
